import { useNavigate } from 'react-router'
import { BottomSheet } from './BottomSheet'
import { JoinCodeForm } from './JoinCodeForm'

interface Props {
  open: boolean
  onClose: () => void
  /** Unique per page: the desktop card renders its own form with another id. */
  id: string
  /** Room route prefix: `/r` for XOX, `/ice/r` for a race. */
  path: '/r' | '/ice/r' | '/c4/r' | '/cycles/r'
  title?: string
  label?: string
}

/** The phone "Join" tab's sheet: a join-by-code form that navigates into the room. */
export function JoinSheet({
  open,
  onClose,
  id,
  path,
  title = 'Join a room',
  label = 'Have a code?',
}: Props) {
  const navigate = useNavigate()
  return (
    <BottomSheet open={open} onClose={onClose} title={title}>
      <JoinCodeForm id={id} label={label} onJoin={(code) => navigate(`${path}/${code}`)} />
    </BottomSheet>
  )
}
